module.exports = __webpack_public_path__ + "assets/img/aboutUs_bg2.dbfa53b4.png";